import { BmHttp } from "../utils/Global";
import { notifyCitaFinalizada } from "../utils/citaFinalizadaAlert";

export const Controllerenfermendad = async (route,enfermedad) => {
  try {
    const { data } = await BmHttp().post(`${route}`, enfermedad);
    if (data.success) {
      return data;
    } else {
      return null;
    }
  } catch (error) {
    notifyCitaFinalizada(error);
    return null;
  }
};
export const ControllerMotivoConsulta = async (route,enfermedad) => {
  try {
    const { data } = await BmHttp().post(`${route}`, enfermedad);
    if (data.success) {
      return data;
    } else {
      return null;
    }
  } catch (error) {
    notifyCitaFinalizada(error);
    return null;
  }
};
export const ControllerPlanTratmientos = async (route,enfermedad) => {
  try {
    const { data } = await BmHttp().post(`${route}`, enfermedad);
    if (data.success) {
      return data;
    } else {
      return null;
    }
  } catch (error) {
    notifyCitaFinalizada(error);
    return null;
  }
};
export const ControllerNotasEvolucion = async (route,enfermedad) => {
  try {
    const { data } = await BmHttp().post(`${route}`, enfermedad);
    if (data.success) {
      return data;
    } else {
      return null;
    }
  } catch (error) {
    notifyCitaFinalizada(error);
    return null;
  }
};

export const ControllerReceta = async (receta) => {
  try {
    const { data } = await BmHttp().post("consulta_receta", receta);
    if (data.success) {
      return data;
    } else {
      return null;
    }
  } catch (error) {
    notifyCitaFinalizada(error);
    return null;
  }
};

export const ControllerEliminaReceta = async (idreceta) => {
  try {
    const { data } = await BmHttp().delete("consulta_receta/"+ idreceta );
    if (data.success) {
      return data;
    } else {
      return null;
    }
  } catch (error) {
    notifyCitaFinalizada(error);
    return null;
  }
}

export const ControllerDiagnosticos = async () => {
  try {
    const { data } = await BmHttp().get("consulta_diagnosticos");
    if (data.success) {
      return data;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

export const ControllerDiagnosticoSearch = async (search) => {
  try {
    const { data } = await BmHttp().post("consulta_diagnosticos", { search });
    if (data.success) {
      return data;
    } else {
      return { success: false, data: [], message: data?.message || "No se pudo buscar el diagnóstico." };
    }
  } catch (error) {
    // AUDITORIA-CLINICA-WORKFLOW-44 (bug CIE10): antes se devolvia `null` sin
    // distincion, indistinguible de "sin resultados" para quien llama -- el
    // catalogo parecia simplemente no cargar, sin ningun error visible.
    return { success: false, data: [], message: "Error de red al buscar el diagnóstico." };
  }
};
